import React from "react";
import { useLang } from "../i18n";
import { MessageCircle, Instagram } from "lucide-react";

export default function Contact() {
  const { t } = useLang();
  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-[#EDE3DA]">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="text-xs uppercase tracking-[0.28em] text-[#5E7891] mb-5">{t.contact.eyebrow}</p>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#2D3640]">{t.contact.title}</h2>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a data-testid="contact-whatsapp" href="https://wa.me/351931777823?text=Hello%21%20I%20would%20like%20information%20about%20Porto%20Beyond%20the%20Postcard."
            target="_blank" rel="noreferrer"
            className="btn-sweep inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#D8B07A] text-[#FDFAF3] text-sm tracking-wider hover:bg-[#5E7891] transition-colors">
            <MessageCircle size={16} strokeWidth={1.6} /> {t.contact.whatsapp}
          </a>
          <a data-testid="contact-instagram" href="https://www.instagram.com/portobeyondpostcards" target="_blank" rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-[#2D3640]/30 text-[#2D3640] text-sm tracking-wider hover:bg-[#FDFAF3] transition-colors">
            <Instagram size={16} strokeWidth={1.6} /> {t.contact.instagram}
          </a>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-5 text-sm text-[#5E7891]">
          <a data-testid="contact-whatsapp-number" className="inline-flex items-center gap-1.5 hover:text-[#2D3640] transition-colors" href="https://wa.me/351931777823?text=Hello%21%20I%20would%20like%20information%20about%20Porto%20Beyond%20the%20Postcard." target="_blank" rel="noreferrer">
            <MessageCircle size={14} strokeWidth={1.6} /> +351 931 777 823
          </a>
          <span className="hidden sm:inline text-[#C98C97]">·</span>
          <a data-testid="contact-instagram-handle" className="inline-flex items-center gap-1.5 hover:text-[#2D3640] transition-colors" href="https://www.instagram.com/portobeyondpostcards" target="_blank" rel="noreferrer">
            <Instagram size={14} strokeWidth={1.6} /> @portobeyondpostcards
          </a>
        </div>
      </div>
    </section>
  );
}
